import { useCallback } from "react";
import { usePatient } from "@src/packages/patients/hooks/usePatient";
import { useQueuedPatientUpdate } from "@src/packages/patients/sync/usePatientSync";
import {
  useMedicationsVaccines,
  MedicationsVaccinesState,
} from "./MedicationsVaccinesContext";
import { transformMedicationsVaccinesStateToRequest } from "./transformMedicationsVaccinesStateToRequest";

export function useSubmitMedicationsVaccines() {
  const { state } = useMedicationsVaccines();
  const { data: patient } = usePatient();
  const { mutateAsync, isPending } = useQueuedPatientUpdate();

  const submit = useCallback(
    async (overrideState?: MedicationsVaccinesState) => {
      const payload = transformMedicationsVaccinesStateToRequest(
        overrideState ?? state,
      );

      // Include the medicalHistory ID so the API updates the existing record
      const medicalHistoryId = patient?.medicalHistory?.id;
      if (payload.medicalHistory && medicalHistoryId) {
        payload.medicalHistory.id = medicalHistoryId;
      }

      await mutateAsync(payload);
    },
    [state, patient, mutateAsync],
  );

  return { submit, isPending };
}
